/**
 *  Copyright (c) 2022-present TVM Engineering Authors.
 *
 */

import types from '../actions/types';
// import { ROLES } from '../config';

const INITIAL_STATE = {
	projects: [],
	projectsByUserId: [],
};

export default function projectReducer(state = INITIAL_STATE, action) {
	switch (action.type) {
		case types.GET_ALL_PROJECTS:
			return { ...state, projects: action.payload };
		case types.GET_PROJECTS_BY_USER_ID:
			return { ...state, projectsByUserId: action.payload };
		default:
			return state;
	}
}

// Selectors
export const getProjectsReducer = (state) => {
	return state.project.projects;
}
export const getProjectsByUserIdReducer = (state) => {
	return state.project.projectsByUserId;
}

